export default __webpack_public_path__ + "static/media/tradesman-insurance 2.5cbce67d.png";